// FAZ-10.6 / K-36 — "Kullanıldığı sayfalar" paneli. Bileşeni kullanan (cmp_ bloğu
// taşıyan) sayfaları listeler; her satır sayfa düzenlemeye derin link. Endpoint
// (`GET admin/components/{id}/usages`) BE'de henüz canlı olmayabilir → 404'te
// query error'a düşer ve panel GİZLENİR (degrade), UI kırılmaz.

import { Button, Card, Empty, List, Spin, Tag } from 'antd';
import { ExternalLink } from 'lucide-react';
import { useNavigate } from 'react-router-dom';
import { useTranslation } from 'react-i18next';
import { useQuery } from '@tanstack/react-query';
import { componentsApi } from '@api/components';
import { ROUTES } from '@shared/constants/routes';

interface ComponentUsagesPanelProps {
  componentId: string;
}

const STATUS_COLOR: Record<string, string> = {
  Published: 'green',
  Draft: 'default',
  Archived: 'orange',
};

export function ComponentUsagesPanel({ componentId }: ComponentUsagesPanelProps) {
  const { t } = useTranslation('component-studio');
  const tr = t as unknown as (key: string) => string;
  const navigate = useNavigate();

  const { data, isLoading, isError } = useQuery({
    queryKey: ['component-usages', componentId],
    queryFn: () => componentsApi.usages(componentId),
    enabled: !!componentId,
    retry: false,
  });

  // Endpoint yoksa/erişilemezse paneli hiç gösterme (gizli-degrade).
  if (isError) return null;

  const usages = data ?? [];

  return (
    <Card size="small" title={t('editor.usages.title')} style={{ marginTop: 16 }} data-testid="component-usages">
      {isLoading ? (
        <Spin size="small" />
      ) : usages.length === 0 ? (
        <Empty image={Empty.PRESENTED_IMAGE_SIMPLE} description={t('editor.usages.empty')} />
      ) : (
        <List
          size="small"
          dataSource={usages}
          renderItem={(u) => (
            <List.Item
              actions={[
                <Button
                  key="open"
                  type="link"
                  size="small"
                  icon={<ExternalLink size={13} />}
                  onClick={() => void navigate(ROUTES.PAGE_EDIT.replace(':id', u.pageId))}
                >
                  {t('editor.usages.open')}
                </Button>,
              ]}
            >
              <List.Item.Meta title={u.title || u.pageId} />
              {u.status ? <Tag color={STATUS_COLOR[u.status] ?? 'default'}>{tr(`status.${u.status}`)}</Tag> : null}
            </List.Item>
          )}
        />
      )}
    </Card>
  );
}
